import React from "react";
import {
  InfoCircle,
  CheckCircle,
  ErrorCircle,
  WarningCircle
} from "../../icons";
const AlertIcon = ({ level, ...props }) => {
  switch (level) {
    case "info":
      return /* @__PURE__ */ React.createElement(InfoCircle, {
        ...props
      });
    case "success":
      return /* @__PURE__ */ React.createElement(CheckCircle, {
        ...props
      });
    case "error":
      return /* @__PURE__ */ React.createElement(ErrorCircle, {
        ...props
      });
    case "warning":
      return /* @__PURE__ */ React.createElement(WarningCircle, {
        ...props
      });
    default:
      return null;
  }
};
export default AlertIcon;
